module.exports = require('./lib/static/prefixAll')



//////////////////
// WEBPACK FOOTER
// /workspace/donate-gro-release/~/inline-style-prefixer/static.js
// module id = 319
// module chunks = 6